import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import { getLease, getLeaseNotFound } from '../reducers';

const withLease = (DecoratedComponent) => {
  let WithLease = ({ children, ...props }) => {
    return React.createElement(DecoratedComponent, props, children);
  };

  const mapStateToProps = (
    state,
    {
      match: {
        params: { leaseId },
      },
    },
  ) => {
    const lease = getLease(state, leaseId);

    return {
      lease,
      notFound: getLeaseNotFound(state, leaseId),
      leaseId,
    };
  };

  WithLease = withRouter(connect(mapStateToProps, null)(WithLease));

  const WithLeaseRoute = ({ children, ...props }) => (
    <Route path="/leases/:leaseId" component={WithLease} {...props} />
  );

  return WithLeaseRoute;
};

export default withLease;
